import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const ViewRequestsModalEmptyState = () => {
  return (
    <Box justify="center" align="center" px={24} height="100%" flow={4}>
      <Text size="large" color="secondaryText" fontWeight="semibold">
        No pair requests
      </Text>
      <Text size="normal" color="secondaryText" textAlign="center">
        You do not have any agencies requesting to pair with you at this time.
      </Text>
    </Box>
  );
};

export default ViewRequestsModalEmptyState;
